var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('filter-event',{attrs:{"range":_vm.range},model:{value:(_vm.event),callback:function ($$v) {_vm.event=$$v},expression:"event"}}),_vm._v(" "),_c('filter-checkboxes',{attrs:{"options":_vm.options,"enableCount":false},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf0d4520","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/filter-event-service.vue
// module id = null
// module chunks = 